import { useEffect } from "react";
import { useAuth } from "@clerk/react";
import { registerTokenGetter } from "@/lib/authToken";

// Mounted once inside <ClerkProvider>. Registers Clerk's real getToken() with
// the module-level bridge so the plain axios client (lib/api.js) can fetch a
// fresh per-request token without needing the hook itself. Renders nothing.
export function ClerkTokenBridge() {
  const { isLoaded, isSignedIn, getToken } = useAuth();

  useEffect(() => {
    if (!isLoaded) return;
    registerTokenGetter(isSignedIn ? getToken : async () => null);
  }, [isLoaded, isSignedIn, getToken]);

  return null;
}
